export const ENRICHMENT_TYPE = {
  CONTACT: 0,
  ORGANISATION: 1,
  EMAIL: 2,
};

export const ENRICHMENT_TYPE_LABELS = {
  [ENRICHMENT_TYPE.CONTACT]: 'Contact',
  [ENRICHMENT_TYPE.ORGANISATION]: 'Organisation',
  [ENRICHMENT_TYPE.EMAIL]: 'Email',
};

export const ENRICHMENT_STATUS = {
  PROCESSING: 0,
  COMPLETED: 1,
  FAILED: 2,
};

export const StatusPipConfig = {
  [ENRICHMENT_STATUS.PROCESSING]: {
    text: 'Processing',
    background: '#fef9e9',
    color: '#f1c21b',
    tooltip:
      'Your enrichment is currently in progress. Depending on the size of the data, this may take a few moments.',
  },
  [ENRICHMENT_STATUS.COMPLETED]: {
    text: 'Completed',
    background: '#eff8f9',
    color: '#56b3c3',
    tooltip: 'Your enrichment is complete',
  },
  [ENRICHMENT_STATUS.FAILED]: {
    text: 'Failed',
    background: '#fce9ea',
    color: '#da1e28',
    tooltip:
      'Your enrichment has failed. Please try again or contact customer success if the issue persists.',
  },
};
